import _ from 'lodash';

export const getUserCurrencyFromStore = store => {
  const userStore = store.user;
  return _.get(userStore.userDetails, 'currency', 'HKD');
};
